import { MChatMember } from './chat-member';
import { MChatMessage } from './chat-message';

interface IChatConversationProps {
  id: number;
  recipient: MChatMember;
  unreadMessageCount: number;
  lastMessage: MChatMessage | null;
}

export class MChatConversation {
  props: IChatConversationProps;

  constructor(props: IChatConversationProps) {
    this.props = props;
  }

  get hasLastMessage() {
    return this.props.lastMessage !== null;
  }

  get hasUnreadMessages() {
    return this.props.unreadMessageCount > 0;
  }

  clearUnreadMessages() {
    this.props.unreadMessageCount = 0;
  }

  setLastMessage(message: MChatMessage) {
    this.props.lastMessage = message;
  }
}
